import { ICON__upload } from '@/assets/icons_fa';
import { useToast } from '@/hooks/use-toast';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list } from '@/utils/_methods/FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list';
import { upload_images_multiple } from '@/utils/utils_upload';
import { assert_equal } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { useTranslation } from 'react-i18next';
import { G_BUTTON__image_asset_create_base } from '../../image_asset/_buttons/G_BUTTON__image_asset_create_base';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_BUTTON__image_asset_list_upload({ field }: PROPS) {
  assert_equal(field.category, ENUM__image_asset_category.IMAGE);

  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  /*
   *
   */

  async function onClick() {
    if (field.items.length >= CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT) return;

    let images_limit = CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT - field.items.length;

    upload_images_multiple(
      toast,
      file_data_list => FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list(file_data_list, field),
      t_base_ui,
      images_limit,
    );
  }

  /*
   *
   */
  return <G_BUTTON__image_asset_create_base {...{ onClick, field }} text="Upload" Icon={ICON__upload} />;
}
